import actions from './actions';

const initState = {
	dataMultipleAnswer: [],
	readMultipleAnswer: {},
	totalItems: 0,
	loading: false,
};

export default function learnerReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_MULTIPLE_ANSWER:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_MULTIPLE_ANSWER_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataMultipleAnswer: res, totalItems, loading: false };

		case actions.GET_MULTIPLE_ANSWER_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_MULTIPLE_ANSWER_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, readMultipleAnswer: res, loading: false };
		}

		case actions.READING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
